const togglePassword = document.querySelectorAll('.toggle-pass-btn');
const password = document.querySelectorAll('.toggle-pass');

togglePassword.forEach(function(e, i) {
    togglePassword[i].addEventListener('click', function (e) {
        const type = password[i].getAttribute('type') === 'password' ? 'text' : 'password';
        password[i].setAttribute('type', type);
        this.classList.toggle('ryd-view');
    });
})